import React from "react";
import "./Loading.css";

export default function Loading() {
  return (
    <div className="loadingWrapper centeredFlex">
      <img className="loading" src="/images/loader.gif" alt="loading gif" />
    </div>
  );
}
